import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import {
  pcmpEditPermissionQueryKeys,
  savePcmpEditPermission,
} from '../api/pcmpEditPermissions.api';
import type { PcmpEditGrant } from '../types/pcmpEditPermissions.types';

interface SaveVariables {
  userId: number;
  userName: string;
  editAnyStage: boolean;
  proposalCorrection: boolean;
}

/** Set one user's edit grants; errors stay inline in the dialog (the caller reads `error`). */
export function useSavePcmpEditPermission(onSuccess?: (grant: PcmpEditGrant) => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, editAnyStage, proposalCorrection }: SaveVariables) =>
      savePcmpEditPermission(userId, { editAnyStage, proposalCorrection }),
    onSuccess: (grant, variables) => {
      void queryClient.invalidateQueries({ queryKey: pcmpEditPermissionQueryKeys.all() });
      toast.success(
        grant.editAnyStage || grant.proposalCorrection
          ? `Permissions saved for ${variables.userName}`
          : `All PCMP edit permissions were withdrawn from ${variables.userName}`,
      );
      onSuccess?.(grant);
    },
  });
}
